(function () {
  var sec = document.querySelector('[data-product-section]');
  if (!sec) return;
  var dataEl = document.getElementById('pdp-variants');
  var form = sec.querySelector('form');
  if (!dataEl || !form) return;

  var variants = JSON.parse(dataEl.textContent);
  var idInput = form.querySelector('input[name="id"]');
  var priceEl = sec.querySelector('#pdp-price');
  var btn = sec.querySelector('#pdp-add');

  function sync() {
    var selected = [];
    form.querySelectorAll('input[type="radio"]:checked').forEach(function (r) { selected.push(r.value); });
    if (!selected.length) return;
    var match = variants.find(function (v) {
      return v.options.every(function (o, i) { return o === selected[i]; });
    });
    if (!match) {
      btn.disabled = true;
      btn.textContent = 'Unavailable';
      return;
    }
    idInput.value = match.id;
    priceEl.textContent = match.price;
    btn.disabled = !match.available;
    btn.textContent = match.available ? 'Add to bag' : 'Sold out';
  }

  form.addEventListener('change', sync);

  var mainImg = document.getElementById('pdp-main-img');
  sec.querySelectorAll('.thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = t.getAttribute('data-src');
    });
  });
})();
